/* eslint-disable @typescript-eslint/no-explicit-any */
export const isPWA = () =>
  window.matchMedia("(display-mode: standalone)").matches ||
  (window.navigator as any).standalone === true;

export const isIOS = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;

export const isPWAiOS = () => isPWA() && isIOS();

export const isFirefox = () => /Firefox/i.test(navigator.userAgent);

export const isIOSSafari = () =>
  isIOS() && /Safari/i.test(navigator.userAgent) && !/CriOS|FxiOS|OPiOS|EdgiOS/i.test(navigator.userAgent);
